import { render, staticRenderFns } from "./UpdateVisibilityModal.vue?vue&type=template&id=b4b57fd8&scoped=true&"
import script from "./UpdateVisibilityModal.vue?vue&type=script&lang=js&"
export * from "./UpdateVisibilityModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateVisibilityModal.vue?vue&type=style&index=0&id=b4b57fd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b57fd8",
  null
  
)

export default component.exports